import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { TabsetComponent } from './tabset/tabset.component';
import { TabComponent } from './tab/tab.component';
import { VisiblePipe } from './tabset/visible.pipe';
import { FormlyFieldTabComponent } from './types/tab';
import { FormlyFieldTabsetComponent } from './types/tabset';
import { FormlyWrapperTabComponent } from './wrappers/tab';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule.forChild({
      types: [
        { name: 'tab', component: FormlyFieldTabComponent },
        { name: 'tabset', component: FormlyFieldTabsetComponent },
      ],
      wrappers: [{ name: 'tab', component: FormlyWrapperTabComponent }],
    }),
  ],
  declarations: [
    TabsetComponent,
    TabComponent,
    FormlyFieldTabsetComponent,
    FormlyFieldTabComponent,
    FormlyWrapperTabComponent,
    VisiblePipe,
  ],
  exports: [TabsetComponent, TabComponent],
})
export class FormlyTabsModule {}
